// TODO - Type 'any' needs to be fixed.
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import React from "react";
import { useTranslation } from "react-i18next";

type ReviewWorkerAssignShiftCheckboxProps = {
    iAmSure?: boolean;
    setIAmSure?: (value: boolean) => void;
};

const ReviewWorkerAssignShiftCheckbox = ({
  iAmSure,
  setIAmSure,
}: ReviewWorkerAssignShiftCheckboxProps) => {
  const { t } = useTranslation();
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={iAmSure}
          onChange={() => setIAmSure && setIAmSure(!iAmSure)}
          name="amISureCheckbox"
          id="amISureCheckbox"
          color="primary"
        />
      }
      label={t("scheduler_confirm-assign-workers-checkbox")}
      style={{ marginRight: "auto", marginLeft: "0px" }}
    />
  );
};

export default ReviewWorkerAssignShiftCheckbox;
